interface EnvironmentalStatusBadgeProps {
  status: string;
}

const config: Record<string, { badge: string; label: string }> = {
  "Ativa": { badge: "bg-primary-100 text-primary-700", label: "Ativa" },
  "Em implantação": { badge: "bg-accent-100 text-accent-700", label: "Em implantação" },
  "Em manutenção": { badge: "bg-caution-100 text-caution-700", label: "Em manutenção" },
  "Em recuperação": { badge: "bg-warning-100 text-warning-700", label: "Em recuperação" },
  "Pendente de vistoria": { badge: "bg-warning-100 text-warning-700", label: "Pendente de vistoria" },
  "Crítica": { badge: "bg-danger-100 text-danger-700", label: "Crítica" },
  "Inativa": { badge: "bg-background-200 text-foreground-500", label: "Inativa" },
  "Planejada": { badge: "bg-background-200 text-foreground-500", label: "Planejada" },
  "Criada": { badge: "bg-accent-100 text-accent-700", label: "Criada" },
  "Sem plano de manejo": { badge: "bg-warning-100 text-warning-700", label: "Sem plano de manejo" },
  "Com plano de manejo": { badge: "bg-primary-100 text-primary-700", label: "Com plano de manejo" },
  "Em revisão": { badge: "bg-caution-100 text-caution-700", label: "Em revisão" },
  "Irregular": { badge: "bg-danger-100 text-danger-700", label: "Irregular" },
  "Vigente": { badge: "bg-primary-100 text-primary-700", label: "Vigente" },
  "Aprovado": { badge: "bg-primary-100 text-primary-700", label: "Aprovado" },
  "Arquivado": { badge: "bg-background-200 text-foreground-500", label: "Arquivado" },
  "Disponível": { badge: "bg-primary-100 text-primary-700", label: "Disponível" },
  "Pendente": { badge: "bg-warning-100 text-warning-700", label: "Pendente" },
  "Em andamento": { badge: "bg-accent-100 text-accent-700", label: "Em andamento" },
};

export default function EnvironmentalStatusBadge({ status }: EnvironmentalStatusBadgeProps) {
  const cfg = config[status] || { badge: "bg-background-200 text-foreground-500", label: status };
  return (
    <span className={`badge ${cfg.badge}`}>{cfg.label}</span>
  );
}